export default __webpack_public_path__ + "static/media/info.d70390e6.png";